import { api } from 'common';

import { GetFormSetFormFields } from './FormFields';
import { getFormSetBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getFormSetNodeConfig: BlockConfigProps<api.FlowDefinition.GetFormSetBlock['config']> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'getFormSet',
    defaultConfig: {
      type: api.FlowDefinition.GetFormSetType.AutomaticallyApplied,
      searchScope: api.FlowDefinition.FormSetSearchScope.CurrentPractice,
    },
    configFields: {
      schema: api.FlowDefinition.GetFormSetBlockConfigSchema,
      FormFields: GetFormSetFormFields,
    },
    documentationMarkdown: getFormSetBlockDocumentationMarkdown,
  };
